import { render, staticRenderFns } from "./UpcomingGame.vue?vue&type=template&id=cf27e250&scoped=true"
import script from "./UpcomingGame.vue?vue&type=script&lang=js"
export * from "./UpcomingGame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf27e250",
  null
  
)

export default component.exports